/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const template = require('./site-details.tpl');
require('./site-details.scss');

require('components/common/AMap/AMap')
require('components/base/pop/pop');
const store = require('appVuex/store');

const tip = require('components/base/pop/tip');
const ajaxHttp = require('appUtil/ajaxHttp');
const { apiPath } = require('appService/api');
require('appUtil/ajaxSetting');
require('rootPath/src/common/components/lib/filter.js');

const { setBreadCrumb } = require('src/common/vuex/action/common');

const siteDetails = {
	template,
	store,
	vuex: {
		actions: {
			setBreadCrumb,
		}
	},
	data() {
		return {
			thItems: ["序号","用户名","手机号","评分信息", "评论内容", "评论照片","评论时间","操作"],
			url: apiPath.charge.commentList,
			detailUrl: apiPath.charge.spotDetail,
      commentUrl: apiPath.charge.commentDetail,
			comStatusUrl: apiPath.charge.commentStatus,

      queryArgs: {
        "_index": 1,
        "_size": 10
      },
			spotDetail: {},
			commentDetail: {},
			detailInfo: {
				"author": "",
				"authorId": "",
				"phone": "",
				"score": "",
				"priceScore": "",
				"aroundScore": "",
				"serviceScore": "",
				"content": "",
				"pictures": ""
			},
			spotID: "",
      showHideMessage: "--",
      status: null,
      commentID: null,
      address: {
      	"provice": "",
      	"city": "",
      	"district": "",
      	"address": ""
      },
      hasPictures: null,
      hasFeesInfo: null,
      feesInfo: {
      	"elec": "",
      	"elecPeriod": ""
      },

      elecPeriodItems: {},
      showPeriodFees: false,
      AMapBol: false
		}
	},
	route:{
		data(transtion){
			this.spotID = this.$route.query.spotID;
    	ajaxHttp(this.detailUrl, {
        data: { spotID: this.spotID}
      })
			.then((res) => {
				if(res.code == 0){
					this.spotDetail = res.data;
          this.feesInfo = this.spotDetail['feesInfo'];

          this.address = res.data.map;
					// this.spotID = res.data["spotID"];

          this.$refs.spotMap.getAddress(this.address);
          transtion.next();
				}
			}).catch((res) => {
				// tip(res.messsage);
				transtion.next();
			});
   	  

		},
		waitForData: true
		
	},
	ready() {

    this.queryArgs = Object.assign({}, this.queryArgs, {"spotId": this.spotID});
    this.$refs.tableData.query(this.queryArgs).fetch();
	},

	methods: {
		initMap(map) {
			this.AMapBol = true;
		},
		comment() {
			//评论跳转
			this.$route.router.go({
				path:"/page/charge/siteLists/detail/comment",
				query: {"spotID": this.spotID}
			})
		},
		showComment(commentId, spotId) {
			this.commentDetail = this.detailInfo;
			this.$refs.userstatus.show();
			// let $el = $(".page-layout .pop");
			// $el.css({top: "2%"});

			this.getCommentData(commentId, spotId);  //请求评论参数
		},
		getDetailData() {
			ajaxHttp(this.detailUrl, {
        data: { spotID: this.spotID}
      })
			.then((res) => {
				if(res.code == 0){
					this.spotDetail = res.data;
          this.feesInfo = this.spotDetail['feesInfo'];

          this.address = res.data.map;
					// this.spotID = res.data["spotID"];

          this.$refs.spotMap.getAddress(this.address);
				}
			}).catch((res) => {
				// tip(res.messsage);
			});
		},
		getCommentData(commentId, spotId) {
			ajaxHttp(this.commentUrl, {
        "type": "GET",
        "data": {"commentId": commentId, "spotId": spotId}
        // "data": {"commentId": commentId}
      }).then((res) => {
				if(res.code == 0){
					this.commentDetail = res.data;
          this.hasPictures = this.commentDetail['pictures'].length > 0;
				}
			}).catch((res) => {
				// tip(res.messsage);
			});
		},
    showHide(status, id) {
      this.status = status;
      this.commentID = id;
      this.$refs.showHideStatus.show();

      if (status == 0){
        this.showHideMessage = "隐藏";
      } else {
        this.showHideMessage = "显示";
      }
    },
    displayComfirm() {

      ajaxHttp(this.comStatusUrl, {
        type: "POST",
        data: {"id": this.commentID, "isVisible": parseInt(this.status), "model": "spotMark"}
      }).then((res) => {

        if (res.code === 0){
          this.$refs.showHideStatus.hide();
          this.$refs.tableData.fetch();
        }

      }).catch((res) => {
        // tip(res.messsage);
      });
    }
	},

	filters: {
		filterData(val) {
			return val ? val : "---"
		},
		filterNetType(type){
			let netType = {
				"0": "未联网",
				"1": "已联网"
			}
			return netType[type]
		},
		filterType(type) {
			let typeList = {
				"0": "个人",
				"1": "公共",
				"2": "运营"
			}
			return `${typeList[type]}站点`
		},
		filterPileNum(num) {
			return `${num}个电桩`
		},
		filterFee(item) {
      if (item) {
        let perCount = (item.value).toFixed(1);
        return ` ${perCount}元/度`
      } else {
      	return ` 暂无`
      }
		},
		filterGrade(val) {
			return val ? `${val}分` : '--';
		},
		filterTotalGrade(val) {
			return val ? `${val}星` : '--';
		},
    filterPicture(val) {
      return `${val}张`
    }
	}
}
module.exports = siteDetails;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/charge/site-details/site-details.js